import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconArrowLeft } from '@redteclab/icons'

import { Button, DialogContent, DialogTitle } from 'base-ui'

import { useCartIntermediateContext } from '../../hooks/useCartIntermediateContext'

import { CartIntermediateSpecialOffersCrossSellWidget } from './CartIntermediateSpecialOffersCrossSellWidget'

export const CartIntermediateSpecialOffersContent: FC = () => {
  const {
    specialOffersCollapsibleControls: { handleClose },
  } = useCartIntermediateContext()
  const closeButton: FC = () => (
    <Button
      className="text-dark-brand"
      onClick={handleClose}
      size="small"
      startIcon={<IconArrowLeft />}
      variant="text"
    >
      <FormattedMessage id="seller.modal.reviews.back" />
    </Button>
  )

  return (
    <>
      <DialogTitle
        className="flex-row-reverse items-center gap-2"
        slots={{ closeButton }}
      >
        <FormattedMessage id="cartIntermediate.drawer.specialOffers.title" />
      </DialogTitle>
      <DialogContent className="p-8">
        <CartIntermediateSpecialOffersCrossSellWidget />
      </DialogContent>
    </>
  )
}
